import React, { Component } from "react";
import qs1 from "../images/qs1.png";
import breadcrumbs from "../images/breadcumbs.jpg";
import { Link } from "react-router-dom";
import Footer from "../component/Footer";
import { TbSearch, TbShape2 } from "react-icons/tb";
import { ImCreditCard } from "react-icons/im";
import { ImQrcode } from "react-icons/im";
import { BsSim } from "react-icons/bs";
import apiCall from "../utils/apiCall";
import NumberBox from "./common/NumberBox";
import HeaderNav from "./common/HeaderNav";
import GlobalAdvancedSearchBar from "./common/GlobalAdvancedSearchBar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./styles/Number.css";

const bestOfferStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "500px",
  background: `url(${breadcrumbs}) no-repeat center center`,
  backgroundSize: "cover",
  opacity: 0.3,
  zIndex: 0,
};

let mountLimit = 1;

class Home extends Component {
  state = {
    headerSliderImages: [],
    homeNumbers: [],
    bestOfferNumber: null,
    todaysOfferNumbers: [],
    categoryGridData: [],
    infoNumber: {},
    infoModelOpen: false,
    searchBarText: "",
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    document.title =
      "Buy VIP Mobile Numbers in India | Premium & Fancy Numbers | VIP Number Studio";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Get exclusive VIP mobile numbers in India at VIP Number Studio. Choose from premium, fancy, and unique numbers for personal or business use. Secure yours today!"
      );
    if (mountLimit == 1) {
      mountLimit++;
      try {
        let homeConfigArrivalNumbers = [];
        let bestOfferNumber = null; // To store the full best offer number info
        let todaysOfferNumbers = []; //To store the full todays offer number info

        const { result: homeConfig } = await apiCall(
          "REACT_APP_GET_HOME_CONFIG",
          "POST",
          {
            limit: 20,
            skip: 0,
          },
          false
        );

        if (homeConfig && homeConfig["success"] && homeConfig["status"]) {
          let modifyData = await this.modifyApiData(homeConfig.status);
          homeConfigArrivalNumbers = modifyData.homeConfigArrivalNumbers;
          this.setState({ headerSliderImages: modifyData.imageUrl });
          this.setState({ todaysOfferNumbers: modifyData.todaysOffer });
          // Store only the best offer number
          this.setState({ categoryGridData: modifyData.categoryGridData });
          this.setState({ bestOfferNumber: modifyData.bestOffer });
        }
        const { result: getNumbers } = await apiCall(
          "REACT_APP_GET_NUMBERS",
          "POST",
          homeConfigArrivalNumbers.length !== 0
            ? {
                number: homeConfigArrivalNumbers,
                limit: 20,
                skip: 0,
              }
            : {
                limit: 6,
                skip: 0,
                status: [2],
              }
        );

        if (getNumbers && getNumbers["success"] && getNumbers["status"]) {
          let modifyData = await getNumbers["status"].map((data) => {
            data.createdAt = new Date(data.createdAt).toLocaleString();
            data.updatedAt = new Date(data.updatedAt).toLocaleString();
            data["operationDelete"] = data.id;
            return data;
          });
          this.setState({ homeNumbers: modifyData });
        }

        // Fetch full best offer number details
        if (this.state.bestOfferNumber) {
          const bestOfferNumbersArray = [this.state.bestOfferNumber.number];
          const { result: bestOfferData } = await apiCall(
            "REACT_APP_GET_NUMBERS",
            "POST",
            { number: bestOfferNumbersArray, limit: 1, skip: 0 }
          );

          if (
            bestOfferData &&
            bestOfferData["success"] &&
            bestOfferData["status"].length > 0
          ) {
            bestOfferNumber = bestOfferData["status"][0];
            console.log(bestOfferNumber);
          }
        }
        // fetch full todays offer number details
        if (this.state.todaysOfferNumbers) {
          const todaysOfferNumbersArray = this.state.todaysOfferNumbers.map(
            (number) => number.number
          );
          const { result: todaysOfferData } = await apiCall(
            "REACT_APP_GET_NUMBERS",
            "POST",
            { number: todaysOfferNumbersArray, limit: 6, skip: 0 },
            false
          );

          if (
            todaysOfferData &&
            todaysOfferData["success"] &&
            todaysOfferData["status"].length > 0
          ) {
            todaysOfferNumbers = todaysOfferData["status"]; // Store full number details
          }
        }

        this.setState({ todaysOfferNumbers });
        this.setState({ bestOfferNumber });
      } catch (error) {
        console.log("Home componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    console.log("rawDataArray", rawDataArray);

    let imageUrl = [];
    let homeConfigArrivalNumbers = [];
    let bestOffer = [];
    let categoryGridData = [];
    let todaysOffer = [];

    await rawDataArray.forEach((data) => {
      console.log("data", data);
      if (
        data.homeConfigName == "headerImages" &&
        typeof data.jsonArray == "string"
      ) {
        let jsonArray = JSON.parse(data.jsonArray);

        if (Array.isArray(jsonArray)) {
          jsonArray.forEach((obj) => {
            imageUrl.push({ url: obj.imageUrl });
          });
        }
      }
      if (
        data.homeConfigName == "New Arrivals" &&
        typeof data.jsonArray == "string"
      ) {
        let jsonArray = JSON.parse(data.jsonArray);

        if (Array.isArray(jsonArray)) {
          jsonArray.forEach((obj) => {
            homeConfigArrivalNumbers.push(obj.number);
          });
        }
      }
      if (
        data.homeConfigName == "Best Offer" &&
        typeof data.jsonArray == "string"
      ) {
        let jsonArray = JSON.parse(data.jsonArray);

        if (Array.isArray(jsonArray)) {
          bestOffer = jsonArray[0];
        }
      }
      if (
        data.homeConfigName == "Todays Offer" &&
        typeof data.jsonArray == "string"
      ) {
        let jsonArray = JSON.parse(data.jsonArray);

        if (Array.isArray(jsonArray)) {
          todaysOffer = jsonArray;
        }
      }
      if (
        data.homeConfigName == "Category Section" &&
        typeof data.jsonArray == "string"
      ) {
        let jsonArray = JSON.parse(data.jsonArray);

        if (Array.isArray(jsonArray)) {
          categoryGridData = jsonArray;
        }
      }
    });

    return {
      imageUrl,
      homeConfigArrivalNumbers,
      bestOffer,
      todaysOffer,
      categoryGridData,
    };
  }
  closeModel = (closeModelKey) => {
    console.log("closeModelKey", closeModelKey);
    if (closeModelKey) {
      let updateState = {};
      updateState[closeModelKey] = false;
      this.setState(updateState);
    }
  };

  handleShopNowClick = (categoryData) => {
    if (categoryData && categoryData.categoryId) {
      window.location.href = `/numbers?categoryId=${categoryData.categoryId}`;
    } else {
      window.location.href = "/numbers";
    }
  };

  renderCategoryBentoGrid() {
    const { categoryGridData } = this.state;

    if (!categoryGridData || categoryGridData.length === 0) return null;

    return (
      <div className="bento-container">
        <div className="bento-grid">
          {/* Main featured item */}
          <div
            style={{
              backgroundImage: `url(${categoryGridData[0]?.imageUrl})`,
            }}
            className="bento-item bento-item-1"
          >
            <div className="bento-content">
              <h2 className="bento-title">
                {categoryGridData[0]?.categoryName || "VVIP NUMBER"}
              </h2>
              <button
                className="shop-button"
                onClick={() => this.handleShopNowClick(categoryGridData[0])}
              >
                SHOP NOW
              </button>
            </div>
          </div>

          {/* Top right item */}
          <div
            style={{
              backgroundImage: `url(${categoryGridData[1]?.imageUrl})`,
            }}
            className="bento-item bento-item-2"
          >
            <div className="bento-content">
              <h2 className="bento-title">
                {categoryGridData[1]?.categoryName || "MIRROR NUMBER"}
              </h2>
              <button
                className="shop-button"
                onClick={() => this.handleShopNowClick(categoryGridData[1])}
              >
                SHOP NOW
              </button>
            </div>
          </div>

          {/* Far right top item */}
          <div
            style={{
              backgroundImage: `url(${categoryGridData[2]?.imageUrl})`,
            }}
            className="bento-item bento-item-3"
          >
            <div className="bento-content">
              <h2 className="bento-title">
                {categoryGridData[2]?.categoryName || "PENTA NUMBER"}
              </h2>
              <button
                className="shop-button"
                onClick={() => this.handleShopNowClick(categoryGridData[2])}
              >
                SHOP NOW
              </button>
            </div>
          </div>

          {/* Bottom spanning item */}
          <div
            style={{
              backgroundImage: `url(${categoryGridData[3]?.imageUrl})`,
            }}
            className="bento-item bento-item-4"
          >
            <div className="bento-content">
              <h2 className="bento-title">
                {categoryGridData[3]?.categoryName || "2 DIGIT NUMBER"}
              </h2>
              <button
                className="shop-button"
                onClick={() => this.handleShopNowClick(categoryGridData[3])}
              >
                SHOP NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSearchBar = () => {
    return <GlobalAdvancedSearchBar history={this.props.history} />;
  };

  render() {
    console.log("this.state", this.state);

    return (
      <React.Fragment>
        <div className="mainContent">
          <HeaderNav activeTabName="home" />

          {/* Home */}

          <div className="main-slider">
            <div className="container-fluid p-0">
              <div className="row g-0">
                <div
                  id="carouselExampleCaptions"
                  className="carousel carousel-main slide position-relative"
                  data-bs-ride="carousel"
                >
              <Link className="view-link" to="/numbers">
                  <div className="carousel-inner carousel-inner-top">
                    <div className="carousel-item active">
                      <img
                        src={
                          this.state.headerSliderImages
                            ? this.state.headerSliderImages[0]
                              ? this.state.headerSliderImages[0].url
                              : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/BAN3.jpg"
                            : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/BAN3.jpg"
                        }
                        className="d-block pic-1 w-100 img-fluid"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={
                          this.state.headerSliderImages
                            ? this.state.headerSliderImages[1]
                              ? this.state.headerSliderImages[1].url
                              : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/ban1.jpg"
                            : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/ban1.jpg"
                          }
                          className="d-block pic-1 w-100 img-fluid"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={
                          this.state.headerSliderImages
                            ? this.state.headerSliderImages[2]
                              ? this.state.headerSliderImages[2].url
                              : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/ban2.jpg"
                            : "https://techstreat.b-cdn.net/images/C:/repos/vipns/vipns-be/api/common/ban2.jpg"
                        }
                        className="d-block pic-1 w-100 img-fluid"
                        alt="..."
                      />
                    </div>
                  </div>
                  </Link>
                  <button
                    className="carousel-control-prev"
                    style={{ width: "80px" }}
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                      ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    style={{ width: "80px" }}
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="next"
                    >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Box Area */}

          <div className="box_area" style={{ marginBottom: "28px" }}>
            <div className="container">
              <div className="row">
                <div>
                  <h1
                    className="heading"
                    style={{ marginBottom: "28px", textTransform: "uppercase" }}
                  >
                    Buy Premium & Fancy <span className="c-red">VIP</span>{" "}
                    Mobile Numbers in India
                  </h1>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  {this.renderSearchBar()}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "20px",
                  }}
                >
                  {this.state.homeNumbers.map((numberData) => (
                    <div
                      key={numberData.number}
                      style={{
                        minWidth: "300px",
                      }}
                    >
                      <NumberBox
                        numberData={numberData}
                        setCurrentNumber={(data) => {
                          this.setState({
                            infoNumber: data,
                            infoModelOpen: true,
                          });
                        }}
                      />
                    </div>
                  ))}
                </div>

                <div
                  className="d-flex view-div"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <h5 className="viewall-txt">
                    <Link className="view-link" to="/numbers">
                      View All<span className="viewall-arrow">&rarr;</span>
                    </Link>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          {/* Best offer Section */}
          {this.state.bestOfferNumber?.status === 2 && (
            <div className="best-offer-container">
              <div style={bestOfferStyle}></div>
              <div>
                <h1
                  className="mb-2 text-center"
                  style={{
                    fontSize: "65px",
                    fontWeight: "bold",
                    fontFamily: "sans-serif",
                    letterSpacing: "2px",
                    position: "relative",
                    zIndex: "10",
                    background:
                      "linear-gradient(to top,rgb(186, 186, 186), #ffffff)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  BEST OFFER NUMBER
                </h1>
              </div>
              <div className="best-offer-number">
                {this.state.bestOfferNumber?.number}
              </div>
              <div className="best-offer-price">
                ₹{this.state.bestOfferNumber?.discountedPrice}
              </div>
              <Link
                to={`/cart?addtoCart=true&numberId=${this.state.bestOfferNumber?.id}`}
              >
                <button className="best-offer-button">
                  <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                  <span style={{ marginLeft: "16px" }}>Buy Now</span>
                </button>
              </Link>
            </div>
          )}

          {this.state.todaysOfferNumbers.filter((num) => num.status === 2)
            .length > 0 && (
            <div
              className="box_area"
              style={{
                marginBottom: "28px",
                backgroundColor: "#f3f3f3",
                padding: "30px",
                zIndex: 0,
              }}
            >
              <div className="container">
                <div className="row">
                  <div>
                    <h1 className="heading" style={{ marginBottom: "18px" }}>
                      TODAY'S <span className="c-red">SPECIAL</span> OFFER
                    </h1>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    {this.state.todaysOfferNumbers
                      .filter((numberData) => numberData.status === 2)
                      .map((numberData) => (
                        <div
                          key={numberData.number}
                          style={{
                            minWidth: "300px",
                          }}
                        >
                          <NumberBox
                            numberData={numberData}
                            setCurrentNumber={(data) => {
                              this.setState({
                                infoNumber: data,
                                infoModelOpen: true,
                              });
                            }}
                          />
                        </div>
                      ))}
                  </div>
                  <div
                    className="d-flex view-div"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <h5 className="viewall-txt">
                      <Link className="view-link" to="/numbers">
                        View All<span className="viewall-arrow">&rarr;</span>
                      </Link>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="category-grid-section">
            {this.renderCategoryBentoGrid()}
          </div>
          {/* quick steps sections */}

          <div>
            <h1
              className="mb-2 text-center qs-txt"
              style={{ marginTop: "16px" }}
            >
              QUICK STEPS
            </h1>
          </div>
          <div className="container mt-5 qs-container">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-6">
                <div className="phn-img ps-0 my-5">
                  <img src={qs1} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-6 mt-4">
                <div className="d-flex my-4">
                  <div>
                    <TbSearch className="qs-txt-icon srch-icon" />
                  </div>
                  <div>
                    <h3 className="">FIND YOUR DESIRED NUMBER</h3>
                    <p>
                      Select Your Favourable Mobile Number. The One You Like And
                      Which Suits Your Personality.
                    </p>
                  </div>
                </div>
                <div className="d-flex my-4">
                  <div>
                    <ImCreditCard className="qs-txt-icon" />
                  </div>
                  <div>
                    <h3 className="">MAKE THE PAYMENT</h3>
                    <p>
                      Once Your Chosen Mobile Number Is Finalised, Proceed To
                      Checkout And Make The Payment.
                    </p>
                  </div>
                </div>
                <div className="d-flex my-4">
                  <div>
                    <ImQrcode className="qs-txt-icon" />
                  </div>
                  <div>
                    <h3>GET THE UNIQUE PORTING CODE</h3>
                    <p>
                      You Will Receive A Unique Porting Code (UPC) Along With
                      Invoice Within An Hour On Your Registered Mobile Number.
                    </p>
                  </div>
                </div>
                <div className="d-flex my-4">
                  <div>
                    <BsSim className="qs-txt-icon" />
                  </div>
                  <div>
                    <h3>GET YOUR SIM CARD</h3>
                    <p>
                      Visit Any Telecom Gallery Or Mobile Shop And Port The
                      Number. You Can Get Your Number Ported To Any Network, On
                      Your Name.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
